module.exports = __webpack_public_path__ + "media/img/android-icon-96x96-6f568e75937d474420a7415a5d2656c2.png";